import { translateUi } from "@i18n/config";

export const SLUG_RULE_HINT = translateUi(
  "lettersFromAnyLanguageNumbersAndSingleHyphens",
  "Letters from any language, numbers, and single hyphens only.",
);

export const SLUG_REGEX = /^[\p{L}\p{Nd}]+(?:-[\p{L}\p{Nd}]+)*$/u;

function replaceSpecialCases(input: string): string {
  return input
    .replace(/\u00DF/g, "ss")
    .replace(/\u00E6/g, "ae")
    .replace(/\u0153/g, "oe")
    .replace(/\u00F8/g, "o");
}

export function slugify(input: string): string {
  if (!input) return "";

  const normalized = replaceSpecialCases(input.trim().toLowerCase())
    .normalize("NFD")
    .replace(/\p{Mn}/gu, "");

  return normalized
    .replace(/[^\p{L}\p{Nd}\s-]/gu, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .normalize("NFC");
}
